import { hardenFetchXhr } from '@wix/client-security'

const clientHeaders = ['client-binding']

const blockedPaths = ['/_api/v1/access-tokens', '/_api/v2/dynamicmodel', '/_api/one-app-session-web/v3/businesses']

export const hardenFetchAndXHR = () => hardenFetchXhr(blockedPaths, clientHeaders)
